import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

/** A hero's name can't match the given regular expression */
export function isPositiveIntegerValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (Number.isInteger(value) && value >= 1) {
      return null;
    }

    return { isPositiveIntegerError: { value: control.value } };
  };
}

@Directive({
  selector: '[appIsPositiveInteger]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IsPositiveIntegerValidator, multi: true }],
})
export class IsPositiveIntegerValidator implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    return isPositiveIntegerValidator()(control);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/is-positive-integer-validator.ts